import { makeStyles } from '@mui/styles';
import { COLORS } from '../../ObeeTheme';

const useStyles = makeStyles((theme) => ({
  container: (props) => ({
    '& input': {
      '&::placeholder': {
        color: COLORS.NIMBUS,
        ...props?.style?.placeholder,
      },
    },
  }),
}));

export const textFieldStyles = (theme, disabled) => {
  return {
    container: {},
    innerContainer: {
      display: 'flex',
      gap: '10px',
      alignItems: 'baseline',
    },
    label: {
      color: COLORS.SMOKE,
      width: '150px',
      flexShrink: 0,
      marginBottom: 0,
    },
    textFieldInner: {},
    input: {
      border: '1px solid transparent',
      width: '100%',
      color: disabled ? COLORS.NIMBUS : COLORS.CHARCOAL,
      padding: '10px 14px',
      paddingLeft: '14px',
      borderRadius: '6px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      transition: 'background-color 0.1s',
      height: '36px',
    },
    inputActive: {
      outline: `1px solid ${COLORS.SMOKE}`,
    },
    inputHover: {
      backgroundColor: !disabled && COLORS.LIGHT_SHADE,
    },
    placeholder: {
      color: COLORS.NIMBUS,
    },
    textField: {
      width: '100%',
    },
    errorText: {
      margin: '4px 0 0 110px',
      color: COLORS.ERROR_RED,
      fontSize: '10px',
    },
    inputPrefix: {},
    disabled: {
      backgroundColor: COLORS.LIGHT_SHADE,
      borderRadius: '6px',
    },
  };
};

export default useStyles;
